var PES = PES || {};
PES.Chatbot = function () {
    let initChatbot = function (pageUrl) {
        const hostname = new URL(pageUrl).hostname;
        const apiString = "/api/chatbots?state=live";

        const domain = hostname == "localhost" ? "localhost" : hostname.match(/([a-z0-9-]+\.[a-z]+)$/i)[0];

        let cmsHost = "";

        if (domain !== "officetimeline.com") {
            cmsHost = domain == "localhost" ? `https://localhost:1337${apiString}` : `https://compass.pes-integration.com${apiString}`
        } else {
            cmsHost = `https://compass.${domain}${apiString}`
        }

        const router = {
            asPath: window.location.pathname,
        };

        let chatbotData = null;

        const fetchChatbotData = async () => {
            try {
                const response = await fetch(cmsHost);
                const data = await response.json();
                chatbotData = data?.data || null;
                processChatbots();
            } catch (error) {
                console.error("Error fetching chatbot data:", error);
            }
        };

        // Check if path matches
        const isPathInArray = (paths) => {

            return paths.some((path) => {
                if (path.includes("*")) {
                    const basePath = path.replace("*", "");
                    return router.asPath.startsWith(basePath);
                }
                return router.asPath === path;
            });
        };

        // Load chatbot script dynamically
        const loadChatbotScript = (id) => {
            const chatbotInterface = document.querySelector("zapier-interfaces-chatbot-embed");

            if (chatbotInterface && !id) {
                chatbotInterface.style.display = "none";
                return;
            }

            if (!chatbotInterface && id) {
                const script = document.createElement("script");
                script.async = true;
                script.type = "module";
                script.src = "https://interfaces.zapier.com/assets/web-components/zapier-interfaces/zapier-interfaces.esm.js";

                script.onload = () => {
                    const chatbotEmbed = document.createElement("zapier-interfaces-chatbot-embed");
                    chatbotEmbed.setAttribute("is-popup", "true");
                    chatbotEmbed.setAttribute("chatbot-id", id);
                    document.body.appendChild(chatbotEmbed);
                };

                document.head.appendChild(script);
                return;
            }

            if (chatbotInterface && chatbotInterface.getAttribute("chatbot-id") === id) {
                chatbotInterface.style.display = "block";
                return;
            }

            if (chatbotInterface && chatbotInterface.getAttribute("chatbot-id") !== id) {
                chatbotInterface.style.display = "block";
                chatbotInterface.setAttribute("chatbot-id", id);
                return;
            }
        };

        // Process chatbot routing logic
        const processChatbots = () => {

            if (!Array.isArray(chatbotData)) return;

            let activeChatbots = [];

            chatbotData.forEach((item) => {
                const includePaths =
                    item.attributes.includePaths?.split(/[\s,]+/).map((i) => i.trim()) || [];
                const excludePaths =
                    item.attributes.excludePaths?.split(/[\s,]+/).map((i) => i.trim()) || [];

                const isRouteIncluded = includePaths.length > 0 ? isPathInArray(includePaths) : true;
                const isRouteExcluded = excludePaths.length > 0 ? isPathInArray(excludePaths) : false;

                if (isRouteIncluded && !isRouteExcluded) {
                    activeChatbots.push(item.attributes);
                }
            });

            const lowestRankChatbot =
                activeChatbots.length > 0
                    ? activeChatbots.reduce((prev, curr) => (curr.rank < prev.rank ? curr : prev))
                    : null;

            loadChatbotScript(lowestRankChatbot?.chatbotID);
        };

        fetchChatbotData();
    }

    var init = function (envUrl) {
        initChatbot(envUrl);
    };

    return {
        init: init
    };
}();